export default "__VITE_ASSET__D_u8$5Ao__"